import React, { useCallback, useRef, useEffect } from 'react'
import { browserHistory } from 'react-router'
import Datagrid from '../../Component/Table/index'
import User from 'EurestoClass/User'

export default React.memo(props => {

  const metaKeyPressed = useRef(false);
  const handleMetaKeyDown = e => {
    if (e.ctrlKey) {
      metaKeyPressed.current = true;
    }
  };

  const handleMetaKeyUp = e => {
    metaKeyPressed.current = false;
  };

  useEffect(() => {
    document.addEventListener('keydown', handleMetaKeyDown);
    document.addEventListener('keyup', handleMetaKeyUp);
    window.addEventListener('blur', handleMetaKeyUp);
    return () => {
      document.removeEventListener('keydown', handleMetaKeyDown);
      document.removeEventListener('keyup', handleMetaKeyUp);
      window.removeEventListener('blur', handleMetaKeyUp);
    };
  }, []);

  const update = useCallback((row) => {
    if (!metaKeyPressed.current) {
      browserHistory.push({
        pathname: '/crm/' + row.id
      })
    } else {
      window.open('/crm/' + row.id, '_blank');
    }
  }, [])

  return <Datagrid onClick={update}
    type="client"
    search={'client_' + (props.name || '') + User.Entite.get().id} />
})








// WEBPACK FOOTER //
// ./app/App/Module/CRM/Page/Recherche/index.js